import About from './components/aboutPage/About'
import Contact from './components/contactPage/Contact'
import Footer from './components/footerPage/Footer'
import Header from './components/header/Header'
import LandingPage from './components/landingPage/LandingPage'
import Projects from './components/projectsPage/Projects'
import Services from './components/servicePage/Services'
import Skills from './components/skills/Skills'

function App () {
  return (
    <>
      <Header />
      <LandingPage />
      <About />
      <Services />
      <Skills />
      <Projects />
      <Contact />
      <Footer />
    </>
  )
}

export default App
